export enum LOCALES {
	NL = 'nl',
	EN = 'en',
	DE = 'de',
	PL = 'pl'
}
